module.exports = __webpack_public_path__ + "img/c1-2.0bd2b2eb.jpg";